import RouteTemplate from "ember-route-template";
import { LinkTo } from "@ember/routing";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import gt from "truth-helpers/helpers/gt";
import eq from "truth-helpers/helpers/eq";
import lt from "truth-helpers/helpers/lt";
import { concat, get, hash } from "@ember/helper";

const sub = (a, b) => a - b;
const add = (a, b) => a + b;

export default RouteTemplate(
  <template>
    <section class="pd-best-for">
      <div class="pd-best-for__hero">
        <h1 class="pd-best-for__title">
          Proxy <span>Guides</span>
        </h1>
        <p class="pd-best-for__subtitle">
          In-depth, research-backed guides to help you choose, configure,
          and get the most out of proxies.
        </p>
      </div>

      {{#if @controller.model.categories.length}}
        <nav class="pd-guides-filters" aria-label="Guide categories">
          <LinkTo
            @route="proxyviews-guides"
            @query={{hash category=null page=1}}
            class="pd-guides-filters__btn {{unless @controller.model.meta.category 'pd-guides-filters__btn--active'}}"
          >All</LinkTo>
          {{#each @controller.model.categories as |cat|}}
            <LinkTo
              @route="proxyviews-guides"
              @query={{hash category=(get cat 1) page=1}}
              class="pd-guides-filters__btn {{if (eq @controller.model.meta.category (get cat 1)) 'pd-guides-filters__btn--active'}}"
            >{{get cat 0}}</LinkTo>
          {{/each}}
        </nav>
      {{/if}}

      <div class="pd-grid">
        {{#each @controller.model.guides as |g|}}
          <a class="pd-card" href={{g.url}}>
            <div class="pd-card__header">
              <div class="pd-card__title-block">
                <span class="pd-card__type">{{g.categoryLabel}}</span>
                <h3 class="pd-card__name">{{g.title}}</h3>
              </div>
            </div>
            {{#if g.excerpt}}
              <p class="pd-card__excerpt">{{g.excerpt}}</p>
            {{/if}}
            <div class="pd-card__meta-row">
              {{#if g.read_time_minutes}}
                <span class="pd-card__readtime">{{g.read_time_minutes}} min read</span>
              {{/if}}
              {{#if g.freshness_grade}}
                <span class="pd-badge--freshness pd-badge--freshness-{{g.freshness_grade}}">
                  {{g.freshness_grade}}
                </span>
              {{/if}}
            </div>
            {{#if g.author}}
              <div class="pd-card__author">
                {{#if g.author.avatar_url}}
                  <img
                    class="pd-card__author-avatar"
                    src={{g.author.avatar_url}}
                    alt=""
                    width="22"
                    height="22"
                    loading="lazy"
                  />
                {{/if}}
                <span class="pd-card__author-name">{{g.author.display_name}}</span>
              </div>
            {{/if}}
            <div class="pd-card__footer">
              <span class="pd-card__cta">Read guide &rarr;</span>
            </div>
          </a>
        {{else}}
          <div class="pd-empty">
            <div class="pd-empty__icon">&#128218;</div>
            <div class="pd-empty__title">No guides published yet</div>
            <div class="pd-empty__description">Check back soon for expert proxy guides.</div>
          </div>
        {{/each}}
      </div>

      {{#if (gt @controller.model.meta.totalPages 1)}}
        <nav class="pd-pagination" aria-label="Guide pages">
          {{#if (gt @controller.model.meta.page 1)}}
            <LinkTo
              @route="proxyviews-guides"
              @query={{hash page=(sub @controller.model.meta.page 1) category=@controller.model.meta.category}}
              class="pd-pagination__btn"
            >&laquo; Previous</LinkTo>
          {{/if}}

          <span class="pd-pagination__info">
            Page {{@controller.model.meta.page}} of {{@controller.model.meta.totalPages}}
          </span>

          {{#if (lt @controller.model.meta.page @controller.model.meta.totalPages)}}
            <LinkTo
              @route="proxyviews-guides"
              @query={{hash page=(add @controller.model.meta.page 1) category=@controller.model.meta.category}}
              class="pd-pagination__btn"
            >Next &raquo;</LinkTo>
          {{/if}}
        </nav>
      {{/if}}
    </section>
  </template>
);
